<template>
  <v-container>
    <v-row
      v-if="enablePerformanceClientesWeb"
      id="headersPerformanceClientesPrint"
    >
      <v-col
        cols="12"
        sm="12"
        md="12"
        lg="12"
      >
        <v-card
          id="cardDashbord"
          class="mx-auto"
          outlined
        >
          <div class="card-header-dashbord">
            <v-row>
              <v-col
                cols="12"
                sm="10"
                md="10"
                lg="10"
                class="d-flex flex-wrap"
              >
                E aqueles que melhor performaram em ticket médio?
              </v-col>
              <v-col
                cols="12"
                sm="2"
                md="2"
                lg="2"
                class="d-flex justify-end"
              >
                <v-tooltip top>
                  <template
                    v-slot:activator="{ on, attrs }"
                  >
                    <v-icon
                      id="iconInformationFatxMetaComercial4"
                      class="text-left"
                      v-bind="attrs"
                      v-on="on"
                      @mouseover="enableTexto('168')"
                    >
                      mdi-information-outline
                    </v-icon>
                  </template>
                  <div
                    v-if="codigo === '168'"
                    v-html="textoParticpantesPerfomance"
                  />
                </v-tooltip>
              </v-col>
            </v-row>
          </div>
          <v-card-actions>
            <v-row>
              <v-col
                cols="12"
                sm="12"
                md="12"
                lg="12"
              >
                <div
                  v-if="loading"
                  :style="styleObject"
                  class="text-center"
                >
                  <v-icon
                    light
                    class="custom-loader"
                    :style="styleObject"
                  >
                    mdi-cached
                  </v-icon>
                  Carregando dados...
                </div>
                <div
                  v-else-if="error"
                  class="alert alert-danger"
                >
                  {{ error }}
                </div>
                <div
                  v-else
                >
                  <div
                    id="idTable"
                    style="max-width: 100%;"
                  >
                    <table
                      style="width: 100%; overflow-x: auto; color: black; border-collapse: collapse;"
                      class="elevation-1"
                    >
                      <thead>
                        <tr>
                          <th
                            id="dadoMovimentacaoHeader"
                            style="text-align: center;"
                            class="black--text title"
                          >
                            Cliente
                          </th>
                          <th
                            id="dadoMovimentacaoHeader"
                            style="text-align: center;"
                            class="black--text title"
                          >
                            Nº de vendas
                          </th>
                          <th
                            id="dadoMovimentacaoHeader"
                            style="text-align: center;"
                            class="black--text title"
                          >
                            Faturamento
                          </th>
                          <th
                            id="dadoMovimentacaoHeader"
                            style="text-align: center;"
                            class="black--text title"
                          >
                            Ticket médio
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="item in performanceClientes"
                          :key="item.id"
                        >
                          <td
                            id="dadoMovimentacao"
                            style="text-align: left;"
                          >
                            {{ item.nome_cliente }}
                          </td>
                          <td
                            id="dadoMovimentacao"
                            style="text-align: right;"
                          >
                            {{ item.quantidade }}
                          </td>
                          <td
                            id="dadoMovimentacao"
                            style="text-align: right;"
                          >
                            {{ item.faturamento }}
                          </td>
                          <td
                            id="dadoMovimentacao"
                            style="text-align: right;"
                          >
                            {{ item.ticket }}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <router-link
                    to="/clientes/detalhe-cliente-perfomance-ticket-medio"
                    :style="styleObject"
                  >
                    <div
                      id="linkDetalheClienteSemFaturamento"
                      class="text-center"
                    >
                      <v-icon
                        id="iconLinkClienteSemFaturamento"
                        class="text-center"
                      >
                        mdi-chevron-double-down
                      </v-icon><br>
                    </div>
                  </router-link>
                </div>
              </v-col>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
    <v-row
      v-if="enablePerformanceClientesPrint"
      id="performanceClientesPrint"
    >
      <v-row id="performaceClientes">
        <v-col
          id="performaceClientes"
          cols="11"
          class="text-left"
        >
          <v-icon
            id="iconInformationPerformaceClientes"
            class="text-left"
          >
            mdi-clipboard-text
          </v-icon>
          E aqueles que melhor performaram em ticket médio?
        </v-col>
        <v-col
          cols="1"
          class="text-right"
        >
          <v-tooltip top>
            <template
              v-slot:activator="{ on, attrs }"
            >
              <v-icon
                id="iconInformationPerformaceClientes"
                class="text-left"
                v-bind="attrs"
                v-on="on"
                @mouseover="enableTexto('168')"
              >
                mdi-information-outline
              </v-icon>
            </template>
            <div
              v-if="codigo === '168'"
              v-html="textoParticpantesPerfomance"
            />
          </v-tooltip>
        </v-col>
      </v-row>
      <v-col cols="12">
        <v-data-table
          :headers="headersPerformanceClientes"
          :items="performanceClientesPrint"
          :items-per-page="performanceClientesPrint.length"
          fixed-header
          disable-sort
          hide-default-footer
          class="elevation-1"
          style="color: black"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import Clientes from '../../../../../services/clientes'
  import eventEmit from '../../core/EventoEmit'

  export default {
    name: 'ShowClientesExibicaoMelhores',
    emits: ['envioPerformance'],
    components: {
    },
    data: () => ({
      styleObject: {
        color: localStorage.corPrimaria,
      },
      loading: false,
      error: null,
      primeiroDia: (new Date(new Date().getFullYear(), new Date().getMonth(), 1)).toISOString().substr(0, 10),
      ultimoDia: (new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)).toISOString().substr(0, 10),
      select: [],
      vendedorSelect: [],
      areaSelect: [],
      redeSelect: [],
      supervisorSelect: [],
      receita: [],
      segmento: [],
      categoria: [],
      promotor: [],
      headersPerformanceClientes: [
        { text: 'Cliente', value: 'nome_cliente', class: 'black--text title' },
        { text: 'Nº de vendas', value: 'quantidade', align: 'right', class: 'black--text title' },
        { text: 'Faturamento', value: 'faturamento', align: 'right', class: 'black--text title' },
        { text: 'Ticket médio', value: 'ticket', align: 'right', class: 'black--text title' },
      ],
      performanceClientes: [],
      performanceClientesPrint: [],
      enablePerformanceClientesPrint: false,
      enablePerformanceClientesWeb: true,
      orientacao: JSON.parse(localStorage.getItem('orientacaoPartipantes')),
      codigo: 0,
      textoParticpantesPerfomance: '',
      dynamicPaddingPerfomanceParticipantes: '',
    }),

    created () {
      eventEmit.$on('set_faturamento_novos_clientes', this.handleUpdateDados)

      eventEmit.$on('enable-print', this.handleEnablePrint)

      eventEmit.$on('disable-print', this.handleDisablePrint)

      this.updateDynamicPadding()

      window.addEventListener('resize', this.updateDynamicPadding)
    },

    beforeDestroy () {
      eventEmit.$off('set_faturamento_novos_clientes', this.handleUpdateDados)

      eventEmit.$off('enable-print', this.handleEnablePrint)

      eventEmit.$off('disable-print', this.handleDisablePrint)

      window.removeEventListener('resize', this.updateDynamicPadding)
    },

    methods: {
      updateDynamicPadding () {
        if (window.innerWidth > 1800) {
          this.dynamicPaddingPerfomanceParticipantes = 'padding-right: 32rem !important'
        } else if (window.innerWidth > 1380 && window.innerWidth <= 1800) {
          this.dynamicPaddingPerfomanceParticipantes = 'padding-right: 10.6rem !important'
        } else if (window.innerWidth > 380 && window.innerWidth < 600) {
          this.dynamicPaddingPerfomanceParticipantes = 'padding-right: 4rem !important'
        } else {
          this.dynamicPaddingPerfomanceParticipantes = 'padding-right: 14rem !important'
        }
      },

      handleUpdateDados (primeiroDia, dataFinal, select, vendedor, area, rede, supervisor, receita, segmento, categoria, promotor) {
        this.primeiroDia = primeiroDia
        this.ultimoDia = dataFinal
        this.select = select
        this.vendedorSelect = vendedor
        this.areaSelect = area
        this.redeSelect = rede
        this.supervisorSelect = supervisor
        this.receita = receita
        this.segmento = segmento
        this.categoria = categoria
        this.promotor = promotor

        this.showDadosPerformanceTicketMedio()
      },

      handleEnablePrint (value) {
        this.enablePerformanceClientesPrint = value
        this.enablePerformanceClientesWeb = false
      },

      handleDisablePrint (value) {
        this.enablePerformanceClientesPrint = false
        this.enablePerformanceClientesWeb = value
      },

      async showDadosPerformanceTicketMedio () {
        this.loading = true
        this.performanceClientes = []

        await Clientes.showPerformanceTicketMedio(this.primeiroDia, this.ultimoDia, this.select, localStorage.tokencontrato, this.vendedorSelect, this.areaSelect, this.redeSelect, this.supervisorSelect, this.receita, this.segmento, this.categoria, this.promotor).then(resposta => {
          if (resposta.data.status) {
            this.performanceClientes = resposta.data.dadosTicketClientes.map((item) => {
              var listaMelhoresClientes = ({
                nome_cliente: item.nome_cliente,
                quantidade: item.quantidade,
                faturamento: item.faturamento.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
                ticket: item.ticket.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
              })
              return listaMelhoresClientes
            })

            for (var i = 0; i < 35 && i < this.performanceClientes.length; i++) {
              this.performanceClientesPrint.push(this.performanceClientes[i])
            }
          } else if (resposta.data.msg === 'Não há dados de performance de ticket médio no período selecionado') {
            this.performanceClientes = []

            this.showSnackbar('error', 3000, resposta.data.msg)
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = e.message
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        }).finally(f => {
          this.loading = false

          eventEmit.$emit('envio-performance', this.headersPerformanceClientes, this.performanceClientes)
        })
      },

      enableTexto (value) {
        var i = 0

        this.orientacao = JSON.parse(localStorage.getItem('orientacaoPartipantes'))

        this.codigo = value

        for (i in this.orientacao) {
          if (this.orientacao[i].codigo === '168') {
            this.textoParticpantesPerfomance = this.orientacao[i].descricao
          }
        }
      },
    },
  }
</script>

<style scoped>
  #cardDashbord {
    border-radius: 14px;
    border: 1px solid rgba(0,0,0,0.05);
    box-shadow:
      0 2px 4px rgba(0,0,0,0.08),
      0 6px 12px rgba(0,0,0,0.06),
      0 12px 24px rgba(0,0,0,0.04);
    transition: all 0.25s ease;
    transform: translateY(-3px);
    box-shadow:
      0 4px 8px rgba(0,0,0,0.10),
      0 12px 22px rgba(0,0,0,0.09),
      0 20px 32px rgba(0,0,0,0.06);
  }

  .card-header-dashbord {
    background-color: #ffffff;
    padding: 14px 18px;
    font-weight: 600;
    font-size: 14px;
    color: black;
    border-bottom: 1px solid #b7b1b1;
    border-radius: 14px 14px 0 0;
  }

  /* #performanceClientesPrint {
    margin: 52rem 0 0 0;
  } */

  .custom-loader {
    animation: loader 1s infinite;
    display: flex;
    @-moz-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @-webkit-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @-o-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)
  }

  #idTable {
    overflow-x: auto;
    overflow-y: auto;
    max-height: 600px;
  }

   #dadoMovimentacao {
    font-size: 12px;
  }

  table {
    width: 100%;
    border-collapse: collapse;
    font-family: Roboto, sans-serif;
    border: 1px solid #e0e0e0;
  }

  thead th {
    position: sticky;
    top: 0;
    z-index: 2;
    background-color: #f5f5f5;
  }

  th, td {
    border: 1px solid #e0e0e0;
    padding: 10px;
    color: #424242;
  }

  thead {
    background-color: #f5f5f5;
  }

  tbody tr:hover {
    background-color: #f0f0f0;
  }

  #dadoMovimentacaoHeader {
    font-size: 12px !important;
    font-weight: 800 !important;
  }

  #listItemDevolucaoParticipantes {
    margin: -2rem 0 0 -1rem;
  }

  #listItemPerfomanceParticipantes {
    margin: -2rem 0 0 -1rem;
  }

  @media screen
  and (min-device-width : 360px)
  and (max-device-width : 680px) {
     #headersPerformanceClientes {
      width: 100% !important;
    }

     #idTable {
      max-height: 500px;
    }

    #dadoMovimentacao {
      font-size: 8.5px !important;
    }

    th, td {
      padding: 8px;
    }
  }

  @media screen
  and (min-width : 681px)
  and (max-width : 960px)
  and (-webkit-min-device-pixel-ratio: 1) {
    #headersPerformanceClientes {
      width: 100% !important;
    }
  }
</style>
